import {
  fetchAll,
  fetchFiltered,
  addShippingMethodTransportation,
  show,
  edit,
} from "@/api/shippingmethodtransportation";

const state = {
  all: [],
  isLoading: false,
  shippingMethodTransportation: null,
};

const actions = {
  cleanState({ commit }) {
    commit("cleanState");
  },

  async fetchById({ dispatch, commit }, id) {
    try {
      const shippingMethodTransportation = await show(id);

      commit("setShippingMethodTransportation", shippingMethodTransportation);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    }
  },

  async fetchAll({ dispatch, commit }) {
    try {
      const shippingMethodTransportations = await fetchAll();

      commit("setAll", shippingMethodTransportations);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    }
  },

  async fetchFiltered({ dispatch, commit }, queriesParams) {
    try {
      const shippingMethodTransportations = await fetchFiltered(queriesParams);

      commit("setAll", shippingMethodTransportations);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    }
  },

  async create({ dispatch, commit }, data) {
    try {
      commit("setLoading", true);

      await addShippingMethodTransportation(data);

      return true;
    } catch (e) {
      dispatch("notify/error", e, { root: true });

      return false;
    } finally {
      commit("setLoading", false);
    }
  },

  async edit({ dispatch, commit }, { id, data }) {
    try {
      commit("setLoading", true);

      await edit(id, data);

      return true;
    } catch (e) {
      dispatch("notify/error", e, { root: true });

      return false;
    } finally {
      commit("setLoading", false);
    }
  },
};

const mutations = {
  cleanState(state) {
    state.all = [];
    state.isLoading = false;
    state.shippingMethodTransportation = null;
  },

  setAll(state, shippingMethodTransportations) {
    state.all = shippingMethodTransportations;
  },

  setShippingMethodTransportation(state, shippingMethodTransportation) {
    state.shippingMethodTransportation = shippingMethodTransportation;
  },

  setLoading(state, isLoading) {
    state.isLoading = isLoading;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
